<template>
    <div :class="{ 'border': border }" class="wow fadeInUp flex flex-col justify-start" data-wow-delay=".15s"
        style="visibility: visible; animation-delay: 0.15s">
        <div v-if="icon" class="mb-6 flex justify-center">
            <Icon :name="icon" class="text-[var(--white)] fill-content text-5xl font-extralight " />
        </div>
        <div v-if="image_url && !bottom_image" class="mb-6 flex justify-center">
            <img :src="image_url" :srcset="image_srcset" :sizes="image_srcset ? image_sizes : undefined"
                :width="image_width" :height="image_height" :alt="imageAlt"
                :loading="image_lazy ? 'lazy' : undefined" :decoding="image_lazy ? 'async' : undefined"
                :class="image_40 ? 'h-24 object-contain' : ''" />
        </div>
        <div>
            <h3 class="box-title mb-5 flex items-center" v-if="title"
                :class="{ 'sm:text-center sm:justify-center': center, 'text-left': !center }">
                <Badge color="gray" :label=index! v-if="index" class="mr-4" />{{ title }}
            </h3>
            <p class="box-description pr-[10px]" v-if="body"
                :class="{ 'sm:text-center sm:justify-center': center, 'text-left': !center }" v-html="body">
            </p>
        </div>
        <div v-if="button_text && button_link" class="flex mt-6 parent-arrow-icon">
            <a :href="button_link" class="btn-secondary btn mb-2 font-semibold text-left">
                <span v-if="button_text">{{ button_text }}</span>
                <Icon name="ic:round-keyboard-arrow-right" class="arrow-icon" />
            </a>
        </div>
        <div v-if="image_url && bottom_image" class="min-w-full mt-4 sm:mt-6 b-0 flex items-start">
            <img :src="image_url" :srcset="image_srcset" :sizes="image_srcset ? image_sizes : undefined"
                :width="image_width" :height="image_height" :alt="imageAlt"
                :loading="image_lazy ? 'lazy' : undefined" :decoding="image_lazy ? 'async' : undefined"
                :style="{ maxWidth: '100%', objectFit: 'contain' }" :class="image_40 ? 'h-24 object-contain' : ''" />
        </div>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        image_url: String,
        image_40: Boolean,
        // Intrinsic pixel size of image_url, used to reserve layout space and avoid CLS.
        image_width: Number,
        image_height: Number,
        image_srcset: String,
        image_sizes: String,
        image_lazy: Boolean,
        icon: String,
        title: String,
        body: String,
        total: String,
        index: String,
        bottom_image: Boolean,
        border: Boolean,
        button_text: String,
        button_link: String,
        center: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        imageAlt(): string {
            if (!this.title) return '';
            return this.index ? `Step ${this.index}: ${this.title}` : this.title;
        },
    },
};
</script>